import { Button, Chip } from '@material-tailwind/react';
import { UserCogIcon } from 'lucide-react';
import React from 'react';
import { useSendResetPasswordEmail, useUpdateUserStatus } from '../../../custom-hooks/use-users';
import { useConfirm } from '../../../custom-hooks/confirm-dialog';

const AccountManagement = ({ customer }) => {
    const updateUserStatusMutation = useUpdateUserStatus();
    const sendResetPasswordEmailMutation = useSendResetPasswordEmail();
    const { confirm, ConfirmationDialog } = useConfirm();

    const handleUpdateUserStatus = async () => {
        const confirmed = await confirm({
            title: `${customer.isActive ? 'Disable' : 'Enable'} Account`,
            message: `Are you sure you want to ${customer.isActive ? 'disable' : 'enable'} ${customer.name}'s account?`,
            confirmText: customer.isActive ? 'Disable' : 'Enable',
            confirmColor: customer.isActive ? 'red' : 'green'
        });

        if (!confirmed) return;

        updateUserStatusMutation.mutate({ userId: customer._id, status: !customer.isActive });
    }

    const handleSendResetPasswordEmail = async () => {
        const confirmed = await confirm({
            title: 'Send Reset Password Email',
            message: `Send a reset password email to ${customer.email}?`,
            confirmText: 'Send Email',
            confirmColor: 'blue'
        });

        if (!confirmed) return;

        sendResetPasswordEmailMutation.mutate({ email: customer.email, userId: customer._id });
    }

    return (
        <div className="border rounded-xl p-6">
            <div className="flex gap-4">
                <h4 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                    <UserCogIcon size={16} />
                    Account Management
                </h4>
            </div>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex justify-between items-center gap-2 bg-gray-200 rounded-lg p-4">
                    <div className="flex gap-2">
                        <p className="text-md text-gray-600">Account Status</p>
                        <Chip color={customer.isActive ? "green" : "red"} size="sm" variant="ghost" value={customer.isActive ? "Active" : "Inactive"} className="rounded-full" />
                    </div>
                    <div className="flex flex-col gap-2">
                        <Button
                            variant="gradient"
                            color={customer.isActive ? "red" : "green"}
                            size="sm"
                            className="rounded-full"
                            loading={updateUserStatusMutation.isLoading}
                            onClick={handleUpdateUserStatus}>
                            {customer.isActive ? "Disable login" : "Enable login"}
                        </Button>
                    </div>
                </div>
                <div className="flex justify-between items-center gap-2 bg-gray-200 rounded-lg p-4">
                    <p className="text-md text-gray-600">Reset Password</p>
                    <div className="flex gap-2">
                        <Button variant="gradient" color="light-blue" size="sm" className="rounded-full" loading={sendResetPasswordEmailMutation.isLoading} onClick={handleSendResetPasswordEmail}>
                            Send Reset Password Email
                        </Button>
                    </div>
                </div>
            </div>
            <ConfirmationDialog />
        </div>
    );
};

export default AccountManagement;